export type Toast = {
  id: string;
  message: string;
};

type ToastInput = {
  message: string;
};

type Listener = (toast: Toast) => void;

const listeners = new Set<Listener>();
let counter = 0;

export function emitToast(input: ToastInput): void {
  counter += 1;
  const toast: Toast = {
    id: `${Date.now().toString(36)}-${counter}`,
    message: input.message,
  };
  listeners.forEach((listener) => {
    listener(toast);
  });
}

export function subscribeToToasts(listener: Listener): () => void {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}

export function clearToasts(): void {
  listeners.clear();
  counter = 0;
}
